(function (upp) {
    'use strict';
    upp

        //Directive to show the breadcrumb
        .directive('cartBreadcrumbTpl', ['appi',
        function (appi) {
            var steps = [
                {
                    step:"order",
                    label:"CART.ORDER",
                    link:"/cart",
                    next:{
                        link:"/cart/address",
                        label:"CART.NEXT",
                        icon:"icon-chevron-right"
                    }
                },
                {
                    step:"address",
                    label:"CART.ADDRESS",
                    link:"/cart/address",
                    next:{
                        func:"next()",
                        label:"CART.NEXT",
                        icon:"icon-chevron-right"
                    }
                },
                {
                    step:"payment",
                    label:"CART.PAYMENT"
                }
            ];

            var getBreadCrumbHtml = function (actualStep, nextDisabled) {
                return appi.utils.breadCrumbTemplate(actualStep, steps, nextDisabled);
            };


            return {
                restrict:'E',
                replace:true,
                compile:function compile(element, attrs) {
                    var html = getBreadCrumbHtml(attrs.cartStep, attrs.nextDisabled);
                    element.replaceWith(html);
                }

            };
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/cart/directives/cart-bread_crumb-directive.js